import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import useLessMinute from './useLessMinute';
import './LessMinuteTimer.scss';

interface LessMinuteTimerProps {
	time: number;
	action: () => void;
}

export const LessMinuteTimer: FunctionComponent<LessMinuteTimerProps> = memo(({ time, action }) => {
	const seconds = useLessMinute(time, action);
	return <div className="less-five">{seconds} sec</div>;
});
